<template>
  <v-fade-transition>
    <v-container
      fluid
      align-center
      fill-height
      justify-center
      v-if="$apollo.loading"
      class="page-loading-container"
    >
      <v-progress-circular
        :width="10"
        :size="70"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-container>

    <div v-else class="frontend-main-body" :class="`page-${slug}`">
      <base-sections
        :sections="sections"
        :templateSettings="templateSettings"
        :pageID="pageBySlug.id"
      ></base-sections>

      <div v-html="dynamicStyle"></div>
    </div>
  </v-fade-transition>
</template>

<script>
import BaseSections from '@/components/sections/BaseSections'
import { mapActions } from 'vuex'
import { activeTemplate } from '@/graphql/template.gql'
import { pageBySlug } from '@/graphql/page.gql'
import swal from 'sweetalert2'

export default {
  name: 'ViewFrontend',
  components: {
    BaseSections
  },
  computed: {
    slug() {
      return (
        this.$route.params.page ||
        this.activeTemplate.pages.filter(page => page.home)[0].slug
      )
    },
    templateSettings() {
      let templateSettings = {
        content: {},
        design: {},
        layout: {},
        advanced: {}
      }

      if (this.activeTemplate) {
        templateSettings.content = this.activeTemplate.content
        templateSettings.design = this.activeTemplate.design
        templateSettings.layout = this.activeTemplate.layout
        templateSettings.advanced = this.activeTemplate.advanced
      }

      return templateSettings
    },
    sections() {
      return this.pageBySlug ? this.pageBySlug.sections : []
    },
    dynamicStyle() {
      return `<style type="text/css">${this.templateSettings.advanced.css}</style>`
    }
  },
  apollo: {
    activeTemplate: {
      query: activeTemplate,
      result({ data }) {
        Object.entries(data.activeTemplate.design).forEach(([key, value]) => {
          document.documentElement.style.setProperty(`--${key}`, value)
        })
      }
    },
    pageBySlug: {
      query: pageBySlug,
      skip() {
        return !this.activeTemplate
      },
      variables() {
        return {
          data: {
            slug: this.slug,
            template_id: this.activeTemplate.id
          }
        }
      },
      result({ data }) {
        if (!data.pageBySlug) {
          this.setError(404)
        }
      }
    }
  },
  methods: {
    ...mapActions('errors', ['setError'])
  },
  beforeRouteLeave(to, from, next) {
    // check if there are unsaved changes
    if (this.$store.state.editor.drawer.changed) {
      swal({
        title: 'Are you sure?',
        text: 'You have unsaved changes that will be lost.',
        type: 'warning',
        confirmButtonText: 'Discard changes',
        cancelButtonText: 'Go back to editing',
        showCancelButton: true,
        allowOutsideClick: false
      }).then(({ value }) => {
        if (value) {
          this.$apolloProvider.defaultClient.resetStore().then(() => {
            this.$store.state.editor.drawer.changed = false
            this.$store.state.editor.drawer.itemID = null

            next()
          })
        }
      })
    } else {
      next()
    }
  }
}
</script>

<style scoped>
.page-loading-container {
  min-height: calc(100vh - 160px);
}
</style>
